import type {Article} from '../types/article';

export const sections = [
  {label: 'Chicago', slug: 'chicago'},
  {label: 'Politics', slug: 'politics'},
  {label: 'Business', slug: 'business'},
  {label: 'Science & Technology', slug: 'science-technology'},
  {label: 'Culture', slug: 'culture'},
  {label: 'Sports', slug: 'sports'},
  {label: 'Investigations', slug: 'investigations'}
] as const;

export type Section = (typeof sections)[number];
export type SectionLabel = Section['label'];

export const sectionPath = (section: Section): string => `/${section.slug}`;

export const findSectionByLabel = (label: string): Section | undefined =>
  sections.find((section) => section.label.toLowerCase() === label.trim().toLowerCase());

export const articlesInSection = (articles: readonly Article[], label: SectionLabel): Article[] =>
  articles.filter((article) => article.section.trim().toLowerCase() === label.toLowerCase());
